import { useEffect, useRef } from "react";
import {
  getChainId,
  getConversionTrackingConfig,
  getCurrentPracticeId,
} from "../../../core/store/chainSlice";
import { useMainStore } from "../../../core/store/mainStore";
import {
  BOOKING_STARTED_EVENT,
  captureTrackingParams,
  ensureGtmLoaded,
  pushBookingEvent,
} from "../../../core/utils/tracking";
import { useWidgetConfig } from "../../../widget/WidgetContext";

/**
 * Initializes conversion tracking for the booking flow. Captures UTM params as early
 * as possible, and — once the chain config has loaded and tracking is enabled — injects
 * the GTM container on the standalone page and fires the "booking started" event once.
 * The embedded widget skips GTM injection: the host website already loads its own GTM.
 */
export const useBookingTracking = () => {
  const { isWidget } = useWidgetConfig();
  const trackingConfig = useMainStore(getConversionTrackingConfig);
  const chainId = useMainStore(getChainId);
  const practiceId = useMainStore(getCurrentPracticeId);
  const startedFired = useRef(false);

  // Capture UTMs immediately — the URL may be rewritten later by the host site.
  useEffect(() => {
    captureTrackingParams();
  }, []);

  useEffect(() => {
    if (!trackingConfig?.enabled || startedFired.current) return;
    if (!isWidget && trackingConfig.gtmContainerId) {
      ensureGtmLoaded(trackingConfig.gtmContainerId);
    }
    pushBookingEvent(BOOKING_STARTED_EVENT, { chainId, practiceId });
    startedFired.current = true;
  }, [
    trackingConfig?.enabled,
    trackingConfig?.gtmContainerId,
    isWidget,
    chainId,
    practiceId,
  ]);
};
